

//Data imports
import AccessMatrix from '@/router/access-matrix'

//View and component imports
//import PlannedConstruction from "@/views/landingpages/PlannedConstruction.vue";
import HeaderCardPage from '@/components/Sections/Containers/HeaderCardsContainer.vue'
const OldGuiFrame = () => import('@/views/landingpages/OldGuiFrame.vue')

const RouterView = () => import('@/views/landingpages/RouterView.vue')
const MyCar = process.env.NODE_ENV === 'production' ? OldGuiFrame : () => import('@/views/mypage/MyWarehouse.vue')
const MyPickingList = process.env.NODE_ENV === 'production' ? OldGuiFrame : () => import('@/views/mypage/MyPickingList.vue')
const MyAccount = () => import('@/views/mypage/MyAccountSimple.vue')
const MyHours = () => import('@/views/mypage/MyHours.vue')
const Sitesettings = () => import('@/views/Sitesettings/Sitesettings.vue')

//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.MyPageTrunk.module,
    display: { key: "servicesystem.pages.page_titles.my_page" },
    icon: "mdi-home-account",
    overrides: {
      sidebar: 'hidden', //triggers v-show="false" whilst still keeping the component node list for the sub menu
    }
  },
  redirect: { name: 'MyPageHome' },
  name: "MyPage",
  path: "/my-page",
  component: RouterView,
  children: [
    {
      //header card page
      meta: {
        icon: "mdi-home-account",
        display: { key: "servicesystem.pages.page_titles.home" },
        authorize: AccessMatrix.MyPageTrunk.module,
        overrides: {
          sidebar: false,
          headercard: false,
        }
      },
      path: "",
      name: "MyPageHome",
      component: HeaderCardPage,
    },

    {
      meta: {
        authorize: AccessMatrix.JobsTrunk.module,
        display: { key: "servicesystem.pages.page_titles.my_page_my_jobs" },
        icon: "mdi-briefcase-account",
      },
      redirect: { name: 'JobList', params: { filter: "my" } },
      path: "myjobs",
      name: "myjobs",
    },

    {
      meta: {
        authorize: AccessMatrix.MyPageTrunk.mycar,
        display: { key: "servicesystem.pages.page_titles.my_page_my_car" },
        icon: "mdi-car",
      },
      path: "mycar",
      name: "MyCar",
      redirect: { name: 'MyInventory' },
      component: RouterView,
      children: [
        {
          meta: {
            display: { key: "Inventory" },
            icon: "mdi-bookshelf",
          },
          path: "inventory",
          name: "MyInventory",
          component: MyCar,
        },
        {
          meta: {
            display: { key: "Pickinglist" },
            icon: "mdi-clipboard-list",
            overrides: {
              header: {
                buttons: ['ArticlePickerBtn'],
              },
            },
          },
          path: "pickinglist",
          name: "MyPickinglist",
          component: MyPickingList,
        },
      ],
    },
    {
      meta: {
        authorize: AccessMatrix.MyPageTrunk.myaccount,
        display: { key: "servicesystem.pages.page_titles.my_page_my_account" },
        icon: "mdi-account-details",
      },
      path: "myaccount",
      name: "MyAccount",
      component: MyAccount,
    },
    {
      meta: {
        authorize: AccessMatrix.MyPageTrunk.myhourlist,
        display: { key: "servicesystem.pages.page_titles.my_page_my_hourlist" },
        icon: "mdi-account-clock",
        overrides: {
          header: {
            buttons: ['NewDialogTriggerBtn', 'ReportDateRangeSelector', 'ExportBtn'],
          },
        }
      },
      path: "myhourlist",
      name: "MyHourlist",
      component: MyHours
    },
    {
      meta: {
        authorize: AccessMatrix.MyPageTrunk.privatesettings,
        display: { key: "servicesystem.pages.page_titles.admin_private_settings" },
        icon: "mdi-application-cog",
        overrides: {
          header: {
            buttons: ['ClearStorageBtn'],
          },
        },
      },
      path: 'sitesettings',
      name: 'SiteSettings',
      component: Sitesettings,
    },
  ],
};

export default trunk;